import StaffListComponent from 'src/components/features/superAdmin/staffListComponent';

const ListStaffPage = () => <StaffListComponent />;

export default ListStaffPage;
